import * as React from 'react'
import {
  Form,
  Col,
  Row,
  Table,
  Input,
  Tooltip,
  Button,
  Modal,
  Popconfirm,
  Checkbox,
  Select,
} from 'antd'
import {
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  UploadOutlined,
  VerifiedOutlined,
  FileAddOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import Layouts from '../components/Layouts'
import moment from 'moment'
import ViewPolicy from './viewPolicy'
import CreditNotecomponent from './CreditNote.js'
import { Link } from 'react-router-dom'
import { Spin } from 'antd'
import WrappedDebitNote from './DebitNote'
import WrappedPolicyHistory from './PolicyHistory'
import apiRequest from '../hooks/ApiRequest.js'
import hasPermissions from '../hooks/Permissions.js'
import EndorseForm from '../components/EndorsAmend.js'
import FinanceManagement from './FinanceManagement.js'
import { withRouter } from 'react-router-dom'
const data = JSON.parse(localStorage.getItem('user'))
const { Option } = Select

class policies extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchBox: null,
      gotData: false,
      showCreditNote: false,
      baseUrl: process.env.REACT_APP_BASE_URL, //john 04 apr 2020
      customerid: localStorage.getItem('customerid'), //john 04 apr 2020
      nationalID: localStorage.getItem('nationalID'),
      isCustomer: data?.role === '309',
      fethcURl: '', //john 04 apr 2020
      customername: '', //john 04 apr 2020
      policyNumberParams: this.props.match.params.policyNumber || null,
      showActiveOnly: true,
      showInactiveOnly: false,
      policyId: localStorage.getItem('PolicyID'),
      policyIdForModalPopup: null,
      visible: false,
      visibleSearch: false,
      filterTable: null,
      ViewPolicy: false,
      creditNote: false,
      credHistory: false,
      RefundPolicyID: 0,
      policyPermissions: {},
      quotationPermissions: {},
      documentPermissions: {},
      selectedPolicyDetail: null,
      baseData: [],
      endorsementPendingList: [],
      statusFilter: 'All',
      name: '',
      loading: false,
      productId: parseInt(localStorage.getItem('productId')),
      productname: localStorage.getItem('productName'),
      isInsurer: JSON.parse(localStorage.getItem('user')),
      roleName: JSON.parse(localStorage.getItem('user'))?.RoleName,
      Today_date: new Date(),
      showEndorsForm: false,
      daysToExpiryFilter: null,
      isActive: true,
      columns: [
        {
          key: '11',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '21',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: '31',
          title: 'Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: '41',
          title: 'End Date',
          dataIndex: 'policyexpirytdate',
        },
        {
          key: '5',
          title: 'Annual Premium',
          dataIndex: 'grandtotalannualpremium',
        },
        {
          key: '51',
          title: 'Term Premium',
          dataIndex: 'grandtotaltermpremium',
          render: totalannualpremium => {
            return parseFloat(totalannualpremium).toFixed(2)
          },
        },
        {
          key: '61',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: '62',
          title: 'Payment Status',
          dataIndex: 'paymentstatus',
          render: status => status || 'Loading...',
        },
        {
          key: '71',
          title: 'Created Date',
          dataIndex: 'createddate',
          render: createddate => moment(createddate).format('YYYY-MM-DD'),
        },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            record.policystatus === 'New Business' ||
              record.policystatus === 'Active' ||
              record.policystatus === 'Endorsed' ? (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}
                {this.state.policyPermissions.hasOwnProperty('12') &&
                  !(
                    this.state.roleName === "Broker" &&   // using RoleName instead of role
                    record.policystatus === "Active" &&
                    record.paymentstatus === "Paid"
                  ) && (
                    <Tooltip title="Edit">
                      <Button
                        type="primary"
                        className="edit_btn"
                        onClick={() => this.handleEditPolicy(record.policyid)}
                      >
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                  )}


                {this.state.policyPermissions.hasOwnProperty('13') && (
                  <>
                    <Popconfirm
                      title="Do you want to cancel the policy?"
                      onConfirm={() => this.handleCancel(record.policyid)}>
                      <Tooltip title="Delete">
                        <Button type="danger">
                          <DeleteOutlined />
                        </Button>
                      </Tooltip>
                    </Popconfirm>
                    &nbsp;&nbsp;&nbsp;
                  </>
                )}
                {this.state.daysToExpiryFilter &&
                  moment(record.policyexpirytdate, 'DD-MM-YYYY HH:mm:ss').diff(
                    moment().startOf('day'),
                    'days',
                  ) <= this.state.daysToExpiryFilter &&
                  moment(record.policyexpirytdate, 'DD-MM-YYYY HH:mm:ss').diff(
                    moment().startOf('day'),
                    'days',
                  ) >= 0 && (
                    <>
                      <Tooltip title="Renew">
                        <Button
                          type="primary"
                          className="renew_btn"
                          onClick={() => this.handleRenew(record.policyid)}
                          style={{ marginLeft: 8 }}>
                          Renew
                        </Button>
                      </Tooltip>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                <Tooltip title="Debit note">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() => this.handleDebitNote(record.policyid)}>
                    Debit Note
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;

                {record.riskitemdetails.reduce((acc, val) => acc + val.refund, 0) > 0 && (
                  <Tooltip title="Credit note">
                    <Button
                      type="primary"
                      className="CreditNote_btn"
                      onClick={() => this.handleCreditNote(record.policyid)}>
                      Credit Note
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;
                {record.policystatus === "Active" &&
                  (
                    this.state.roleName === "Broker" || this.state.roleName === "Customer"
                  ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>
                        <Tooltip title="Endorsement / Amendment">
                          <Button
                            type="primary"
                            className="PayNow_btn"
                            onClick={() => this.handleEndorsForm(record.policyid)}
                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;
                      </>
                    )
                  )}

                {record.policystatus !== 'New Business' && (
                  <Tooltip title="Policy History">
                    <Button
                      type="primary"
                      className="CreditNote_btn"
                      onClick={() =>
                        this.handlePolicyHistory(
                          record.policynumber,
                          record.productid,
                        )
                      }>
                      Policy History{' '}
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;
                {this.state.policyPermissions.hasOwnProperty('21') && (
                  <Button
                    type="primary"
                    className="PayNow_btn"
                    onClick={() =>
                      this.props.history.push(`/payment/${record.policyid}`)
                    }>
                    Pay Now
                  </Button>
                )}

                {/* ✅ Show Endorsement/Amendment button only if Active */}
                {this.state.customerPermissions && record.policystatus === 'Active' && (
                  this.state.roleName === "Broker" || this.state.roleName === "Customer"
                ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>
                        <Tooltip title="Endorsement / Amendment">
                          <Button
                            type="default"
                            style={{ marginLeft: 8 }}
                            onClick={() => this.handleEndorsForm(record.policyid)}
                            visible={this.state.endorsementPendingList.some(x => x.PolicyNumber === record.PolicyNumber)}
                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                      </>
                    )
                  )}

                &nbsp;&nbsp;&nbsp;
                {this.state.documentPermissions.hasOwnProperty('22') &&
                  record.policystatus !== 'Document_verified' &&
                  record.policystatus !== 'Active' && (
                    <Tooltip title="Upload Documents">
                      <Link
                        to={`/policies/documents/${record?.policyid}/${record?.policynumber}/${record?.insurerId}`}
                        className="btn btn-primary">
                        <UploadOutlined />
                      </Link>
                    </Tooltip>
                  )}
              </span>
            ) : record.policystatus === 'Cancelled' ? (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;
                {record.riskitemdetails.reduce((acc, val) => acc + val.refund, 0) > 0 && (
                  <Tooltip title="Credit note">
                    <Button
                      type="primary"
                      className="CreditNote_btn"
                      onClick={() => this.handleCreditNote(record.policyid)}>
                      Credit Note
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;&nbsp;

                <Tooltip title="Policy History">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() =>
                      this.handlePolicyHistory(
                        record.policynumber,
                        record.productid,
                      )
                    }>
                    Policy History{' '}
                  </Button>
                </Tooltip>
              </span>
            ) : (
              <span style={{ display: 'flex' }}>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      success
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}
                {/* &nbsp;&nbsp;&nbsp; */}
                <Tooltip title="Policy History">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() =>
                      this.handlePolicyHistory(
                        record.policynumber,
                        record.productid,
                      )
                    }>
                    Policy History{' '}
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;
                {this.state.policyPermissions.hasOwnProperty('21') &&
                  record.policystatus === 'Document_verified' && (
                    <>
                      <Button
                        type="primary"
                        className="PayNow_btn"
                        onClick={() =>
                          this.props.history.push(`/payment/${record.policyid}`)
                        }>
                        Pay Now
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.policyPermissions.hasOwnProperty('21') &&
                  record.policystatus === 'Renewal' && (
                    <>
                      <Button
                        type="primary"
                        className="PayNow_btn"
                        onClick={() =>
                          this.props.history.push(`/payment/${record.policyid}`)
                        }>
                        Pay Now
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.documentPermissions.hasOwnProperty('22') &&
                  record.policystatus.toLowerCase() === 'document_required' && (
                    <Tooltip title="Upload Documents">
                      <Link
                        to={`/policies/documents/${record?.policyid}/${record?.policynumber}/${record?.insurerId}`}
                        className="btn btn-primary">
                        <UploadOutlined />
                      </Link>
                    </Tooltip>
                  )}
                {this.state.isInsurer?.role === '308' &&
                  (record?.policystatus ===
                    'waiting_for_insurer_authorization' ||
                    record?.policystatus === 'Waiting_For_Authorization') && (
                    <>
                      <Tooltip title="Authorise Policy">
                        <Link
                          to={`/authorise-policy/${record?.policyid}`}
                          className="ant-btn ant-btn-primary">
                          {/* <VerifiedOutlined /> */}
                          Authorise
                        </Link>
                      </Tooltip>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.isInsurer?.role === '308' &&
                  record?.policystatus !== 'Waiting_For_Authorization' && (
                    this.state.roleName === "Broker" || this.state.roleName === "Customer"
                  ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>
                        <Tooltip title="Endorsement Amendment">
                          <Button
                            type="primary"
                            className="PayNow_btn"
                            onClick={() => this.handleEndorsForm(record?.policyid)}
                            visible={this.state.endorsementPendingList.some(x => x.PolicyNumber === record.PolicyNumber)}
                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                      </>
                    )
                  )}

                {/* <label>{this.state.isInsurer?.role}{record?.policystatus}</label> */}
              </span>
            ),
        },
      ],
      columnsForFcp: [
        {
          key: '1',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '2',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: '3',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: '4',
          title: ' Policy Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: '5',
          title: 'Annual Premium',
          dataIndex: 'grandtotalannualpremium',
        },
        {
          key: '51',
          title: 'Term Premium',
          dataIndex: 'grandtotaltermpremium',
          render: totalannualpremium => {
            return parseFloat(totalannualpremium).toFixed(2)
          },
        },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            record.policystatus === 'New Business' ||
              record.policystatus === 'Active' ||
              record.policystatus === 'Endorsed' ? (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}
                {this.state.policyPermissions.hasOwnProperty('12') &&
                  !(
                    this.state.roleName === "Broker" &&
                    record.policystatus === "Active" &&
                    record.paymentstatus === "Paid"
                  ) && (
                    <Tooltip title="Edit">
                      <Button
                        type="primary"
                        className="edit_btn"
                        onClick={() => this.handleEditPolicy(record.policyid)}
                      >
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                  )}

                <Tooltip title="Debit note">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() => this.handleDebitNote(record.policyid)}>
                    Debit Note
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;

                {record.riskitemdetails.reduce((acc, val) => acc + val.refund, 0) > 0 && (
                  <Tooltip title="Credit note">
                    <Button
                      type="primary"
                      className="CreditNote_btn"
                      onClick={() => this.handleCreditNote(record.policyid)}>
                      Credit Note
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;&nbsp;
                {record.policystatus === "Active" && (
                  this.state.roleName === "Broker" || this.state.roleName === "Customer"
                ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>

                        <Tooltip title="Endorsement / Amendment">
                          <Button
                            type="primary"
                            className="PayNow_btn"
                            onClick={() => this.handleEndorsForm(record.policyid)}
                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                        &nbsp;&nbsp;&nbsp;

                      </>
                    )
                  )}

                <Tooltip title="Policy History">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() =>
                      this.handlePolicyHistory(
                        record.policynumber,
                        record.productid,
                      )
                    }>
                    Policy History{' '}
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;
                {this.state.policyPermissions.hasOwnProperty('21') &&
                  record.policystatus === 'Document_verified' && (
                    <>
                      <Button
                        type="primary"
                        className="PayNow_btn"
                        onClick={() =>
                          this.props.history.push(`/payment/${record.policyid}`)
                        }>
                        Pay Now
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.documentPermissions.hasOwnProperty('22') &&
                  record.policystatus !== 'Document_verified' &&
                  record.policystatus !== 'Active' && (
                    <Tooltip title="View">
                      <Link
                        to={`/policies/documents/${record?.policyid}/${record?.policynumber}/${record?.insurerId}`}
                        className="btn btn-primary">
                        <UploadOutlined />
                      </Link>
                    </Tooltip>
                  )}
                {this.state.isInsurer?.role === '308' &&
                  (record?.policystatus ===
                    'waiting_for_insurer_authorization' ||
                    record?.policystatus === 'Waiting_For_Authorization') && (
                    <>
                      <Tooltip title="Authorise Policy">
                        <Link
                          to={`/authorise-policy/${record?.policyid}`}
                          className="ant-btn ant-btn-primary">
                          {/* <VerifiedOutlined /> */}
                          Authorise
                        </Link>
                      </Tooltip>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.isInsurer?.role === '308' && (
                  this.state.roleName === "Broker" || this.state.roleName === "Customer"
                ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>
                        <Tooltip title="Endorsement Amendment">
                          <Button
                            type="primary"
                            className="PayNow_btn"
                            onClick={() => this.handleEndorsForm(record?.policyid)}

                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                      </>
                    )
                  )}
                &nbsp;&nbsp;&nbsp;
                {this.state.daysToExpiryFilter &&
                  moment(record.policyexpirytdate, 'DD-MM-YYYY HH:mm:ss').diff(
                    moment().startOf('day'),
                    'days',
                  ) <= this.state.daysToExpiryFilter &&
                  moment(record.policyexpirytdate, 'DD-MM-YYYY HH:mm:ss').diff(
                    moment().startOf('day'),
                    'days',
                  ) >= 0 && (
                    <Tooltip title="Renew">
                      <Button
                        type="primary"
                        className="renew_btn"
                        onClick={() => this.handleRenew(record.policyid)}
                        style={{ marginLeft: 8 }}>
                        Renew
                      </Button>
                    </Tooltip>
                  )}
                &nbsp;&nbsp;&nbsp;
              </span>
            ) : record.policystatus === 'Cancelled' ? (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}{' '}

                {this.state.policyPermissions.hasOwnProperty('12') && (
                  <Tooltip title="Edit">
                    <Button
                      type="primary"
                      className="edit_btn"
                      onClick={() => this.handleEditPolicy(record.policyid)}>
                      <EditOutlined />
                    </Button>
                  </Tooltip>
                )}
                {record.riskitemdetails.reduce((acc, val) => acc + val.refund, 0) > 0 && (
                  <Tooltip title="Credit note">
                    <Button
                      type="primary"
                      className="CreditNote_btn"
                      onClick={() => this.handleCreditNote(record.policyid)}>
                      Credit Note
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Tooltip title="Policy History">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() =>
                      this.handlePolicyHistory(
                        record.policynumber,
                        record.productid,
                      )
                    }>
                    Policy History{' '}
                  </Button>
                </Tooltip>
              </span>
            ) : (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      success
                      onClick={() => this.handleView(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}
                {this.state.policyPermissions.hasOwnProperty('12') && (
                  <Tooltip title="Edit">
                    <Button
                      type="primary"
                      className="edit_btn"
                      onClick={() => this.handleEditPolicy(record.policyid)}>
                      <EditOutlined />
                    </Button>
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;
                <Tooltip title="Policy History">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() =>
                      this.handlePolicyHistory(
                        record.policynumber,
                        record.productid,
                      )
                    }>
                    Policy History{' '}
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;
                {this.state.policyPermissions.hasOwnProperty('21') &&
                  record.policystatus === 'Document_verified' && (
                    <>
                      <Button
                        type="primary"
                        className="PayNow_btn"
                        onClick={() =>
                          this.props.history.push(`/payment/${record.policyid}`)
                        }>
                        Pay Now
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.documentPermissions.hasOwnProperty('22') &&
                  record.policystatus !== 'Document_verified' &&
                  record.policystatus !== 'Active' && (
                    <Tooltip title="Upload Documents">
                      <Link
                        to={`/policies/documents/${record?.policyid}/${record?.policynumber}/${record?.insurerId}`}
                        className="btn btn-primary">
                        <UploadOutlined />
                      </Link>
                    </Tooltip>
                  )}
                {this.state.isInsurer?.role === '308' &&
                  (record?.policystatus ===
                    'waiting_for_insurer_authorization' ||
                    record?.policystatus === 'Waiting_For_Authorization') && (
                    <>
                      <Tooltip title="Authorise Policy">
                        <Link
                          to={`/authorise-policy/${record?.policyid}`}
                          className="ant-btn ant-btn-primary">
                          {/* <VerifiedOutlined /> */}
                          Authorise
                        </Link>
                      </Tooltip>
                      &nbsp;&nbsp;&nbsp;
                    </>
                  )}
                {this.state.isInsurer?.role === '308' && (
                  this.state.roleName === "Broker" || this.state.roleName === "Customer"
                ) && (
                    !this.state.endorsementPendingList.some(x => x.policyNumber === record.policynumber) && (
                      <>
                        <Tooltip title="Endorsement Amendment">
                          <Button
                            type="primary"
                            className="PayNow_btn"
                            onClick={() => this.handleEndorsForm(record?.policyid)}

                          >
                            Endorsement/Amendment
                          </Button>
                        </Tooltip>
                      </>
                    )
                  )}
              </span>
            ),
        },
      ],
    }
    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.setVisibleFalse2 = this.setVisibleFalse2.bind(this)
    this.EditRecord = this.EditRecord.bind(this)
    this.handleCreditNote = this.handleCreditNote.bind(this)
    this.setVisibleDebitFalse = this.setVisibleDebitFalse.bind(this)
    this.handleRenew = this.handleRenew.bind(this)
  }

  handleRenew(val) {
    localStorage.setItem('clientId', val)
    window.location.href = '/endorsedpolicy'
  }

  search = value => {
    const { baseData } = this.state

    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    this.setState({ filterTable })
  }

  setVisibleDebit() {
    this.setState({ debitNote: true })
  }

  setVisibleDebitFalse() {
    this.setState({ debitNote: false })
    localStorage.removeItem('PolicyID')
    window.location.reload(false)
  }


  handleFilterByStatus = status => {
    if (status === 'All') {
      this.setState({ filterTable: null })
      return
    }

    const filtered = this.state.baseData.filter(
      policy => policy.paymentstatus === status,
    )
    this.setState({ filterTable: filtered })
  }

  fetchEndorsements = async () => {
    const endorsementRes = await apiRequest(
      `${this.state.baseUrl}/Policy/GetAllEndorsements`,
      'GET'
    );
    const endorsements = endorsementRes?.data || [];
    const endorsementPending = endorsements.data.filter(req => req.status === 0);
    this.setState({ endorsementPendingList: endorsementPending })

  }

  fetchPolicies = async () => {
    this.setState({ loading: true })

    try {
      let fetchURL = ''

      if (this.state.nationalID && this.state.nationalID.length > 0) {
        fetchURL = `${this.state.baseUrl
          }/Policy/Getpoliciesbycustomerid/${localStorage.getItem('nationalID')}`
      } else {
        fetchURL = `${this.state.baseUrl}/Policy/GetPolicies/${this.state.productId}/All`
      }

      const response = await apiRequest(fetchURL, 'GET')

      if (response?.success) {
        const policyData = response?.data?.result || response?.data || []

        const enrichedData = await Promise.all(
          policyData.map(async policy => {
            try {
              const paymentHistoryRes = await apiRequest(
                `${this.state.baseUrl}/api/PaypalWebhook/get-transactions-by-policy/${policy.policynumber}`,
                'GET',
              )
              const paymentHistory = paymentHistoryRes?.data || []
              const relatedPayments = Array.isArray(paymentHistory)
                ? paymentHistory
                : []
              const totalPaid = relatedPayments.reduce(
                (sum, payment) => sum + (payment.payment_amount || 0),
                0,
              )
              const premium = parseFloat(relatedPayments ? [0].premium : 0) || 0
              console.log('totalPaid', totalPaid, premium, policy.policynumber)
              let paymentStatus = 'Unpaid'
              if (totalPaid == 0) {
                paymentStatus = 'Unpaid'
              } else if (totalPaid < premium) {
                paymentStatus = 'PartPaid'
              } else if (totalPaid >= premium) {
                paymentStatus = 'Paid'
              } else {
                paymentStatus = '-'
              }

              return {
                ...policy,
                paymentstatus: paymentStatus,
                totalpaid: totalPaid,
              }
            } catch (err) {
              console.error(
                `Payment API failed for policy ${policy.policynumber}:`,
                err,
              )
              return {
                ...policy,
                paymentstatus: 'Error',
                totalpaid: 0,
              }
            }
          }),
        )
        this.setState({
          baseData: enrichedData,
          customername:
            enrichedData.length > 0 ? enrichedData[0].customername : null,
          filterTable: null,
        })
      }
    } catch (error) {
      console.error('Error fetching policies:', error)
    } finally {
      this.setState({ loading: false })
    }
  }

  componentDidMount() {
    const permissions = hasPermissions('Policy')
    const quot_permissions = hasPermissions('Quotation')
    const doc_permissions = hasPermissions('Document')

    this.setState(
      {
        policyPermissions: permissions,
        quotationPermissions: quot_permissions,
        documentPermissions: doc_permissions,
      },
      () => {
        // console.log('Saved Policy permissions', this.state.policyPermissions)
      },
    )

    this.fetchPolicies()
    this.fetchEndorsements()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.baseData !== prevState.baseData &&
      this.state.policyNumberParams
    ) {
      this.search(this.state.policyNumberParams)
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('customerid')
    localStorage.removeItem('nationalID')
  }

  handleCancel(val) {
    localStorage.setItem('PolicyID', val)
    window.location.href = '/cancelPolicy'
  }

  handleView(val) {
    localStorage.setItem('PolicyID', val)
    this.setVisible()
  }

  handleEditPolicy = async (policyId) => {
    // Find the current policy data
    const policy = this.state.baseData.find(p => p.policyid === policyId);
    const previousSumInsured = policy.suminsured;


    const newSumInsured = 0;//parseFloat(prompt("Enter new Sum Insured:", previousSumInsured));

    if (!isNaN(newSumInsured) && newSumInsured < previousSumInsured) {
      // Calculate refund
      const refundAmount = previousSumInsured - newSumInsured;

      policy.refundedamount = refundAmount;
      policy.suminsured = newSumInsured;

      this.setState(prevState => ({
        baseData: prevState.baseData.map(p =>
          p.policyid === policyId ? { ...p, refundedamount: refundAmount, suminsured: newSumInsured } : p
        )
      }));

    }

    localStorage.setItem('clientId', policyId);

    const response = await apiRequest(`${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetProductsbyId/${policy.productid}`, 'GET')

    let isCrmPolicy = response.data.data[0].isCrmProduct || false;
    if (isCrmPolicy) {
      window.location.href = `/home/Crm/EditCrmPolicy/${policyId}`;
    }
    else {
      window.location.href = `/endorsedpolicy/${policyId}`;
    }
  }
  handleCreditNote(val) {
    const policy = this.state.baseData.find(p => p.policyid === val);
    this.setState({ creditNote: true, selectedPolicyDetail: policy });
  }
  handleEndorsForm(val) {
    this.setState({ showEndorsForm: true, policyId: val })
  }
  onhandleChange() {
    alert('sadsad')
  }

  EditRecord(val) {
    this.setState({ name: val })
    // this.setState({startDate:});
    // this.setState({endDate:});
    this.setState({ visible: true })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        alert('asdsadsadsa')
      }
    })
  }
  handleDelete = e => {
    this.setState({ visible: true })
  }

  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }


  setVisibleSearch() {
    this.setState({ visibleSearch: false })
    this.setState({ visible: true })
  }


  setVisible() {
    this.setState({ ViewPolicy: true })
  }

  setVisibleFalse() {
    this.setState({ ViewPolicy: false })
    localStorage.removeItem('PolicyID')
    window.location.reload(false)
  }

  setVisibleFalse2() {
    this.setState({ creditNote: false })
    localStorage.removeItem('PolicyID')
    window.location.reload(false)
  }
  handleDebitNote(val) {
    localStorage.setItem('PolicyID', val)
    this.setVisibleDebit()
  }

  // set localstorage Policy History and it next page for fetching data;
  handlePolicyHistory(policyNumber, productId) {
    //  localStorage.setItem('PolicyID', val)
    console.log(productId)
    this.setState({
      credHistory: true,
      policyIdForModalPopup: policyNumber,
      productId: productId,
    })
  }

  // Functions for search functionality
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    })
  }

  updateInput() {
    if (this.state.searchBox === 'Mayank') {
      alert('Data Found')
    } else {
      this.setState({
        visibleSearch: true,
      })
    }
  }

  handleExpiryFilter = days => {
    this.setState(
      {
        daysToExpiryFilter: days || null,
      },
      this.applyAllFilters,
    )
  }

  handleActiveCheckbox = (e) => {
    this.setState(
      {
        showActiveOnly: e.target.checked,
        showInactiveOnly: false,
        isActive: true,
      },
      () => {
        this.fetchPolicies()
      }
    )
  }

  handleInactiveCheckbox = (e) => {
    this.setState(
      {
        showInactiveOnly: e.target.checked,
        showActiveOnly: false,
        isActive: false,
      },
      () => {
        this.fetchPolicies()
      }
    )
  }

  handleStatusFilterChange = async (value) => {
    // this.setState({ statusFilter: value }, this.applyAllFilters);

    this.setState({ loading: true })

    try {
      let fetchURL = ''

      if (this.state.nationalID && this.state.nationalID.length > 0) {
        fetchURL = `${this.state.baseUrl
          }/Policy/Getpoliciesbycustomerid/${localStorage.getItem('nationalID')}`
      } else {
        fetchURL = `${this.state.baseUrl}/Policy/GetPolicies/${this.state.productId}/${value}`
      }

      const response = await apiRequest(fetchURL, 'GET')

      if (response?.success) {
        const policyData = response?.data?.result || response?.data || []

        const enrichedData = await Promise.all(
          policyData.map(async policy => {
            try {
              const paymentHistoryRes = await apiRequest(
                `${this.state.baseUrl}/api/PaypalWebhook/get-transactions-by-policy/${policy.policynumber}`,
                'GET',
              )
              const paymentHistory = paymentHistoryRes?.data || []
              const relatedPayments = Array.isArray(paymentHistory)
                ? paymentHistory
                : []
              const totalPaid = relatedPayments.reduce(
                (sum, payment) => sum + (payment.payment_amount || 0),
                0,
              )
              const premium = parseFloat(relatedPayments ? [0].premium : 0) || 0
              console.log('totalPaid', totalPaid, premium, policy.policynumber)
              let paymentStatus = 'Unpaid'
              if (totalPaid == 0) {
                paymentStatus = 'Unpaid'
              } else if (totalPaid < premium) {
                paymentStatus = 'PartPaid'
              } else if (totalPaid >= premium) {
                paymentStatus = 'Paid'
              } else {
                paymentStatus = '-'
              }

              return {
                ...policy,
                paymentstatus: paymentStatus,
                totalpaid: totalPaid,
              }
            } catch (err) {
              console.error(
                `Payment API failed for policy ${policy.policynumber}:`,
                err,
              )
              return {
                ...policy,
                paymentstatus: 'Error',
                totalpaid: 0,
              }
            }
          }),
        )

        this.setState({
          filterTable: enrichedData,
          customername:
            enrichedData.length > 0 ? enrichedData[0].customername : null,
          // filterTable: null,
        })
      }
    } catch (error) {
      console.error('Error fetching policies:', error)
    } finally {
      this.setState({ loading: false })
    }
  }

  applyAllFilters = () => {
    const { baseData, daysToExpiryFilter, statusFilter } =
      this.state

    const today = moment().startOf('day')

    const filtered = baseData.filter(policy => {
      const expiryDate = moment(policy.policyexpirytdate, 'DD-MM-YYYY HH:mm:ss')

      const matchesExpiry =
        !daysToExpiryFilter ||
        (expiryDate.isValid() &&
          expiryDate.diff(today, 'days') >= 0 &&
          expiryDate.diff(today, 'days') <= daysToExpiryFilter)

      const status = policy.policystatus?.toLowerCase()

      const matchesStatus =
        statusFilter === 'all' ||
        (statusFilter === 'active' && status === 'active') ||
        (statusFilter === 'inactive' && status !== 'active');

      return matchesExpiry && matchesStatus
    })

    this.setState({ filterTable: filtered })
  }

  // handleExport()
  // {
  //   const fileType = "xlsx"
  //   const ws =   xlsx.utils.json_to_sheet(this.state.baseData)
  //   const wb = {Sheets:{data:ws},SheetNames:["data"]}
  //   const excelBuffer = xlsx.write(wb,{bookType:"xlsx",type:"array"});
  //   const data = new Blob([excelBuffer],{type:fileType})
  //   FileSaver.saveAs(data,"Policies"+".xlsx")
  // }

  render() {
    const { filterTable, baseData } = this.state
    return (
      <Layouts title="assets" classname="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col span={16}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  {/* {this.state.productname}  */}
                  POLICIES{' '}
                </h3>
              </div>
              {/* <div className="customer-list-ul">
                <ul>
                  {this.state.customerid > 0 ||
                  (this.state.customerid != null &&
                    this.state.customername != null) ? (
                    <li>
                      Customer: <span>{this.state.customername}</span>
                    </li>
                  ) : null}
                </ul>
              </div> */}
            </Col>
            <Col xs={24} sm={24} md={12} lg={8}>
              <div className="item-search" style={{ marginTop: 12 }}>
                <Input.Search
                  placeholder="Search ..."
                  enterButton
                  onSearch={this.search}
                  style={{ width: '100%' }}
                />
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="filter-row" align="middle">
            <Col xs={24} sm={24} md={3} lg={6}>
              <label style={{ marginRight: 8 }}>Payment Status:</label>
              <Select
                style={{ width: '100%' }}
                placeholder="Filter by Payment Status"
                onChange={this.handleFilterByStatus}
                defaultValue="All">
                <Option value="All">All</Option>
                <Option value="Paid">Paid</Option>
                <Option value="PartPaid">PartPaid</Option>
                <Option value="Unpaid">Unpaid</Option>
              </Select>
            </Col>

            {/* <Col xs={12} sm={6} md={6} lg={3}>
              <Checkbox
                checked={this.state.showActiveOnly}
                onChange={this.handleActiveCheckbox}
                style={{margin: '8px 0'}}>
                Active
              </Checkbox>
            </Col>
            <Col xs={12} sm={6} md={6} lg={3}>
              <Checkbox
                checked={this.state.showInactiveOnly}
                onChange={this.handleInactiveCheckbox}
                style={{margin: '8px 0'}}>
                Inactive
              </Checkbox>
            </Col> */}
            <Col xs={12} sm={6} md={3} lg={6}>
              <label style={{ marginRight: 8 }}>Policy Status:</label>
              <Select
                // style={{ width: '100%', margin: '8px 0' }}
                value={this.state.statusFilter}
                onChange={(value) => {
                  this.handleStatusFilterChange(value);
                  this.setState({ statusFilter: value });
                }}
                placeholder="Filter by status"
              >
                <Option value="All">All Policies</Option>
                <Option value="Document_required">Document Required</Option>
                <Option value="Document_Uploaded">Document Uploaded</Option>
                <Option value="Document_verified">Document Verified</Option>
                <Option value="waiting_for_insurer_authorization">Waiting for Insurer Authorization</Option>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Col>
            <Col xs={24} sm={12} md={3} lg={6}>
              <label style={{ marginRight: 8 }}>Expiry in:</label>
              <Select
                placeholder="Select days"
                style={{ width: '100%' }}
                onChange={this.handleExpiryFilter}
                allowClear
              >
                <Option value={7}>7 days</Option>
                <Option value={15}>15 days</Option>
                <Option value={30}>30 days</Option>
                <Option value={45}>45 days</Option>
              </Select>
            </Col>

            <Col xs={24} sm={12} md={3} lg={6}>
              {this.state.quotationPermissions.hasOwnProperty('11') && (
                <div className="create-quotation" style={{ marginTop: '9%', display: 'flex', alignItems: 'center', height: '100%' }}>
                  <Link to="/CreateQuotation" className="btn btn-primary">
                    Create Quotation
                  </Link>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-grid-bx policy-table scroll-table-content">
          <Table
            rowKey={record => record.policyid}
            columns={
              this.state.productId === 3 || this.state.productId === 5
                ? this.state.columnsForFcp
                : this.state.columns
            }
            dataSource={filterTable === null ? baseData : filterTable}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <Modal
          title="Policy Details"
          centered
          visible={this.state.ViewPolicy}
          footer={null}
          onCancel={this.setVisibleFalse}
          width={760}>
          <ViewPolicy closeModal={this.setVisibleFalse} />
        </Modal>
        <Modal
          title="Policy Details"
          centered
          visible={this.state.creditNote}
          footer={null}
          onCancel={this.setVisibleFalse2}
          width={760}>
          <CreditNotecomponent policy={this.state.selectedPolicyDetail} />
        </Modal>
        <Modal
          title="Debit Note"
          centered
          visible={this.state.debitNote}
          footer={null}
          onCancel={this.setVisibleDebitFalse}
          width={760}>
          <WrappedDebitNote />
        </Modal>
        <Modal
          title="Policy History"
          centered
          visible={this.state.credHistory}
          footer={null}
          onCancel={() => {
            this.setState({
              credHistory: false,
              policyIdForModalPopup: null,
            })
          }}
          width={768}>
          <WrappedPolicyHistory
            policyNumber={this.state.policyIdForModalPopup}
            productId={this.state.productId}
          />
        </Modal>
        <Modal
          title="Endorsement/Amendment"
          centered
          visible={this.state.showEndorsForm}
          footer={null}
          onCancel={() => {
            this.setState({ showEndorsForm: false })
          }}
          width={768}>
          <EndorseForm
            policyId={this.state.policyId}
            visible={this.state.showEndorsForm}
          />
        </Modal>
      </Layouts>
    )
  }
}

const WrappedPolicies = Form.create({ name: 'normal_login' })(
  withRouter(policies),
)

export default WrappedPolicies
